import * as React from 'react'
import { useState, useCallback, useEffect } from 'react'
import { useControl, Marker } from 'react-map-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'

/* eslint-disable complexity,max-statements */
export default function GeocoderControl(props) {
  const [marker, setMarker] = useState(null)

  const onMarkerDragEnd = useCallback((event) => {
    const { lat, lng } = event.lngLat
    props.addressRefs.setCoordinates({ long: lng, lat })
  }, [])

  const geocoder = useControl(
    () => {
      const ctrl = new MapboxGeocoder({
        ...props,
        marker: false,
        accessToken: props.mapboxAccessToken
      })
      ctrl.on('loading', props.onLoading)
      ctrl.on('results', props.onResults)
      ctrl.on('result', evt => {
        props.onResult(evt)

        const { result } = evt
        const context = result.context || []
        const address = {
          fullAdress: result.place_name,
          street: result.text,
          city: context.find(c => c.id.startsWith('place'))?.text || '',
          state: context.find(c => c.id.startsWith('region'))?.text || '',
          country: context.find(c => c.id.startsWith('country'))?.short_code || '',
          postalCode: context.find(c => c.id.startsWith('postcode'))?.text || ''
        }

        // Poner los valores de cada uno
        let { zipCodeRef, cityRef, stateRef, countryRef, setCoordinates, setFullAddress } = props.addressRefs
        if (address.postalCode) zipCodeRef.current.value = address.postalCode
        if (address.city) cityRef.current.value = address.city
        if (address.state) stateRef.current.value = address.state
        if (address.country) countryRef.current.value = address.country.toUpperCase()
        if (address.fullAdress) setFullAddress(address.fullAdress)

        const location =
          result &&
          (result.center || (result.geometry?.type === 'Point' && result.geometry.coordinates))
        if (location && props.marker) {
          // Aqui se pone la longitud o latitud
          setCoordinates({ long: location[0], lat: location[1] })
          setMarker(<Marker
            {...props.marker}
            longitude={location[0]}
            latitude={location[1]}
            draggable
            onDragEnd={onMarkerDragEnd}
          />)
        } else {
          setMarker(null)
        }
      })
      ctrl.on('error', props.onError)
      return ctrl
    },
    {
      position: props.position
    }
  )

  // @ts-ignore (TS2339) private member
  if (geocoder._map) {
    if (geocoder.getProximity() !== props.proximity && props.proximity !== undefined) {
      geocoder.setProximity(props.proximity)
    }
    if (geocoder.getRenderFunction() !== props.render && props.render !== undefined) {
      geocoder.setRenderFunction(props.render)
    }
    if (geocoder.getLanguage() !== props.language && props.language !== undefined) {
      geocoder.setLanguage(props.language)
    }
    if (geocoder.getZoom() !== props.zoom && props.zoom !== undefined) {
      geocoder.setZoom(props.zoom)
    }
    if (geocoder.getFlyTo() !== props.flyTo && props.flyTo !== undefined) {
      geocoder.setFlyTo(props.flyTo)
    }
    if (geocoder.getPlaceholder() !== props.placeholder && props.placeholder !== undefined) {
      geocoder.setPlaceholder(props.placeholder)
    }
    if (geocoder.getCountries() !== props.countries && props.countries !== undefined) {
      geocoder.setCountries(props.countries)
    }
    if (geocoder.getTypes() !== props.types && props.types !== undefined) {
      geocoder.setTypes(props.types)
    }
    if (geocoder.getMinLength() !== props.minLength && props.minLength !== undefined) {
      geocoder.setMinLength(props.minLength)
    }
    if (geocoder.getLimit() !== props.limit && props.limit !== undefined) {
      geocoder.setLimit(props.limit)
    }
    if (geocoder.getFilter() !== props.filter && props.filter !== undefined) {
      geocoder.setFilter(props.filter)
    }
    if (geocoder.getOrigin() !== props.origin && props.origin !== undefined) {
      geocoder.setOrigin(props.origin)
    }
  }
  return marker
}

const noop = () => { }

GeocoderControl.defaultProps = {
  marker: true,
  onLoading: noop,
  onResults: noop,
  onResult: noop,
  onError: noop
}